import * as React from 'react';
import { AutoSizer, CellMeasurer, CellMeasurerCache, List, ListRowRenderer, Size } from 'react-virtualized';
import SearchQuery from '../search2/SearchQuery';
import SideSearchResult from './SideSearchResult';
import VerseSearchResult from './VerseSearchResult';
import VerseSearchResultText from './VerseSearchResultText';

interface Props {
    results: VerseSearchResult[];
    resultsText?: VerseSearchResultText[];
    query?: SearchQuery;
    onResultClick: (result: object) => void;
}

export default class SearchResultList extends React.Component<Props> {

    private readonly cellMeasurerCache = new CellMeasurerCache({
        defaultHeight: 26,
        fixedWidth: true
    });

    private list: List;

    public constructor(props: Props) {
        super(props);
        this.onAutoSizerResize = this.onAutoSizerResize.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if (this.props.resultsText !== prevProps.resultsText) {
            this.list.forceUpdateGrid();
        }
    }

    public render() {
        return (
            <AutoSizer onResize={this.onAutoSizerResize}>
                {({ width, height }) => (
                    <List
                        width={width}
                        height={height}
                        rowCount={this.props.results.length}
                        estimatedRowSize={this.cellMeasurerCache.defaultHeight}
                        deferredMeasurementCache={this.cellMeasurerCache}
                        rowHeight={this.cellMeasurerCache.rowHeight}
                        rowRenderer={this.rowRenderer}
                        ref={element => this.list = element as List} />
                )}
            </AutoSizer>
        );
    }

    private onAutoSizerResize(info: Size): any {
        this.cellMeasurerCache.clearAll();
        this.list.recomputeRowHeights();
    }

    private readonly rowRenderer: ListRowRenderer = ({ index, key, parent, style }) => {
        return (
            <CellMeasurer
                cache={this.cellMeasurerCache}
                rowIndex={index}
                columnIndex={0}
                key={key}
                parent={parent}>
                <div style={style}>
                    <SideSearchResult
                        result={this.props.results[index]}
                        resultText={this.props.resultsText ? this.props.resultsText[index] : undefined}
                        query={this.props.query}
                        onClick={this.props.onResultClick} />
                </div>
            </CellMeasurer>
        );
    };
}
